var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "client-medicaments"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-prescription', {
    attrs: {
      "do-update": _vm.reloadPrescription,
      "clientId": _vm.clientId,
      "visitId": null
    },
    on: {
      "updated": _vm.updatePrescriptionDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.pharmAnamnesis || _vm.allergicAnamnesis) ? _c('div', {
    staticClass: "card-body bg-danger-light"
  }, [(_vm.allergicAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.allergicAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.allergicAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.allergicAnamnesis.text)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.pharmAnamnesis) ? [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.pharmAnamnesis.anamnesis_type.shortcode) + " - " + _vm._s(_vm.pharmAnamnesis.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pharmAnamnesis.text)
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('add-medicament', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": null,
      "copied-medicament": _vm.medicamentToCopy
    },
    on: {
      "update": _vm.updateMedicament
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  }, [_c('list-previous-medicament', {
    attrs: {
      "client-id": _vm.clientId
    },
    on: {
      "copied": _vm.copyMedicament
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de2e1d4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientMedicament.vue
// module id = 649
// module chunks = 0